import { useMemo } from "react";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import "../../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "../../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import { sortCollectionItems } from "../../../../shared/lib/sort/sortCollectionItems.js";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
function usePrepareModalCheckboxGroupProps({
  options = [],
  value: values = [],
  onChange,
  ...props
}) {
  const groupedOptions = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    options.forEach((option) => {
      const { brand } = option;
      if (!brand) {
        return;
      }
      const value = map.get(brand.id);
      if (!value) {
        map.set(brand.id, [brand, [option]]);
        return;
      }
      const [, acc] = value;
      acc.push(option);
    });
    return Array.from(map.values()).map(
      ([brand, options2]) => {
        const availableModelCheckboxValues = options2.map((option) => option.value);
        const selectedModelCheckboxValues = availableModelCheckboxValues.filter((v) => values.includes(v));
        const otherModelCheckboxValues = values.filter((v) => !availableModelCheckboxValues.includes(`${v}`));
        return [
          brand,
          {
            options: options2,
            value: selectedModelCheckboxValues,
            onChange: (checkedValues) => onChange == null ? void 0 : onChange([...otherModelCheckboxValues, ...checkedValues])
          }
        ];
      }
    ).sort((a, b) => sortCollectionItems(a[0], b[0]));
  }, [onChange, options, values]);
  return {
    options,
    groupedOptions,
    value: values,
    onChange,
    ...props
  };
}
export {
  usePrepareModalCheckboxGroupProps
};
